__turbopack_context__.v({
  "presetItem": "styles-module__uj2ArG__presetItem",
  "presetsList": "styles-module__uj2ArG__presetsList",
  "presetsNav": "styles-module__uj2ArG__presetsNav",
});
